import { AxiosResponse } from 'axios';
import { requests } from '../api';
import {
  INotificationListResponse,
  IMarkNotificationsReadPayload,
} from '../../interface/notification-log.interface';

const NOTIFICATION_BASE_URL = '/notifications';

export const notificationService = {
  // Fetch notifications (GET /v2/notifications)
  getNotifications: (params?: {
    page?: number;
    pageSize?: number;
  }): Promise<AxiosResponse<INotificationListResponse>> => {
    return requests.get(NOTIFICATION_BASE_URL, params);
  },

  // Mark notifications as read (PATCH /v2/notifications/read)
  markNotificationsAsRead: (
    payload: IMarkNotificationsReadPayload,
  ): Promise<AxiosResponse<{ updatedCount: number }>> => {
    return requests.patch(`${NOTIFICATION_BASE_URL}/read`, payload);
  },
};
